import { render, staticRenderFns } from "./TariffDetails.vue?vue&type=template&id=60164a76&scoped=true"
import script from "./TariffDetails.vue?vue&type=script&lang=js"
export * from "./TariffDetails.vue?vue&type=script&lang=js"
import style0 from "./TariffDetails.vue?vue&type=style&index=0&id=60164a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60164a76",
  null
  
)

export default component.exports